import React, { useEffect } from 'react';
import { dynamicImportImages } from '../util';
import styled from 'styled-components';
import SVGA from 'svgaplayerweb';

interface RankBadgeProps {
  rank: number;
  id: string;
}

const Wrap = styled.div`
  display: inline-block;
  width: 81px;
  height: 24px;
  background-size: 100% 100%;
`;

const Giltter = styled.div`
  width: 100%;
  height: 100%;
`;

export default function RankBadge({ rank, id }: RankBadgeProps) {
  useEffect(() => {
    if (rank > 3) {
      let player = new SVGA.Player(`#${id}`);
      let parser = new SVGA.Parser();
      parser.load(
        '//web.yystatic.com/public/common/images/recruit_svga.svga',
        (item: SVGA.VideoEntity) => {
          player.setVideoItem(item);
          player.startAnimation();
        }
      );
    }
  }, [rank, id]);

  const imgPath = dynamicImportImages(`./guild_rank_${rank}.png`);
  return (
    <Wrap style={{ backgroundImage: `url(${imgPath})` }}>
      <Giltter id={id} />
    </Wrap>
  );
}
